import React from "react"
import "./style.scss"
import { HOME_SERVICES_LIST } from "../../data"
import AniLink from "gatsby-plugin-transition-link/AniLink"

function HomeServices() {
  return (
    <div className="container homeServices py-3">
      <div className="row justify-content-evenly align-items-center">
        {HOME_SERVICES_LIST.map((i, ind) => (
          <AniLink
            paintDrip
            hex="#551864"
            to={`/services#${i.heading.split(" ").join("_").toLowerCase()}`}
            className={`bubble col-4 bubble${
              (Math.floor(Math.random() * 10) % 4) + 1
            }`}
            key={ind}
          >
            {i.heading}
          </AniLink>
        ))}
      </div>
    </div>
  )
}

export default HomeServices
